// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__xsXdC","menu_small":"Menu_menu_small__fhVDo","menu_visible":"Menu_menu_visible__TH7N0"};